import api from "./api";

const { vendorServiceAPI } = api;

export type VendorAssessmentEditableTabName = "allergen" | "nutrition" | "recipeRawMaterial";

export type VendorAssessmentEditablePayload =
  | { allergenSectionEditable: boolean }
  | { nutritionSectionEditable: boolean }
  | { recipeRawMaterialSectionEditable: boolean };

export interface SetVendorAssessmentTabEditableArgs {
  vendorAssessmentId: string | number;
  tabName: VendorAssessmentEditableTabName;
  editable: boolean;
}

function buildPayload(
  tabName: VendorAssessmentEditableTabName,
  editable: boolean
): VendorAssessmentEditablePayload {
  if (tabName === "allergen") return { allergenSectionEditable: editable };
  if (tabName === "nutrition") return { nutritionSectionEditable: editable };
  return { recipeRawMaterialSectionEditable: editable };
}

const VendorAssessmentEditableService = {
  _timeoutMs: 120_000,

  /**
   * New API: POST /vendor/assessment/editable?VendorAssessmentId=...&TabName=...
   * Payload varies by tab:
   * - { recipeRawMaterialSectionEditable: boolean }
   * - { nutritionSectionEditable: boolean }
   * - { allergenSectionEditable: boolean }
   */
  setTabEditable: async (args: SetVendorAssessmentTabEditableArgs): Promise<{ id: string; creationDate: number }> => {
    const vendorAssessmentId = String(args.vendorAssessmentId).trim();
    if (!vendorAssessmentId) {
      throw new Error("VendorAssessmentId is required");
    }

    const payload = buildPayload(args.tabName, args.editable);

    const resp = await vendorServiceAPI.post<{ id: string; creationDate: number }>(
      "/vendor/assessment/editable",
      payload,
      {
        // backend expects these exact query param names/casing
        params: { VendorAssessmentId: vendorAssessmentId, TabName: args.tabName },
        timeout: VendorAssessmentEditableService._timeoutMs,
      }
    );

    return resp.data;
  },
};

export default VendorAssessmentEditableService;

